import React from 'react';
import { useTranslation } from '@shared/core';

const ModernGuestList: React.FC = () => {
  const { tq } = useTranslation('guestList');
  const guestList = [
    { firstName: 'John', lastName: 'Doe', rsvp: 'yes' },
    { firstName: 'Jane', lastName: 'Smith', rsvp: 'no' },
    { firstName: 'Alex', lastName: '', rsvp: 'pending' },
    { firstName: 'Emily', lastName: 'Johnson', rsvp: 'yes' },
    { firstName: 'Michael', lastName: 'Williams', rsvp: 'pending' },
    { firstName: 'Sarah', lastName: 'Brown', rsvp: 'no' },
    { firstName: 'David', lastName: 'Jones', rsvp: 'yes' },
    { firstName: 'Jessica', lastName: 'Garcia', rsvp: 'yes' },
    { firstName: 'Daniel', lastName: 'Martinez', rsvp: 'pending' },
    { firstName: 'Ashley', lastName: 'Rodriguez', rsvp: 'no' },
    { firstName: 'Matthew', lastName: 'Lee', rsvp: 'yes' },
    { firstName: 'Amanda', lastName: 'Walker', rsvp: 'pending' },
    { firstName: 'Joshua', lastName: 'Hall', rsvp: 'yes' },
    { firstName: 'Megan', lastName: 'Allen', rsvp: 'no' },
    { firstName: 'Andrew', lastName: 'Young', rsvp: 'yes' },
    { firstName: 'Lauren', lastName: 'Hernandez', rsvp: 'pending' },
    { firstName: 'Ryan', lastName: 'King', rsvp: 'yes' },
    { firstName: 'Brittany', lastName: 'Wright', rsvp: 'no' },
    { firstName: 'Nicholas', lastName: 'Lopez', rsvp: 'yes' },
    { firstName: 'Samantha', lastName: 'Hill', rsvp: 'pending' },
    { firstName: 'Tyler', lastName: 'Scott', rsvp: 'yes' },
    { firstName: 'Elizabeth', lastName: 'Green', rsvp: 'no' },
    { firstName: 'Brandon', lastName: 'Adams', rsvp: 'yes' },
    { firstName: 'Stephanie', lastName: 'Baker', rsvp: 'pending' },
    { firstName: 'Justin', lastName: 'Gonzalez', rsvp: 'yes' },
    { firstName: 'Nicole', lastName: 'Nelson', rsvp: 'no' },
    { firstName: 'Anthony', lastName: 'Carter', rsvp: 'yes' },
    { firstName: 'Heather', lastName: 'Mitchell', rsvp: 'pending' },
    { firstName: 'Kevin', lastName: 'Perez', rsvp: 'yes' },
    { firstName: 'Rachel', lastName: 'Roberts', rsvp: 'no' },
    { firstName: 'Jacob', lastName: 'Turner', rsvp: 'yes' },
    { firstName: 'Michelle', lastName: 'Phillips', rsvp: 'pending' },
    { firstName: 'Zachary', lastName: 'Campbell', rsvp: 'yes' },
    { firstName: 'Melissa', lastName: 'Parker', rsvp: 'no' },
    { firstName: 'Benjamin', lastName: 'Evans', rsvp: 'yes' },
    { firstName: 'Amber', lastName: 'Edwards', rsvp: 'pending' },
    { firstName: 'Alexander', lastName: 'Collins', rsvp: 'yes' },
    { firstName: 'Kayla', lastName: 'Stewart', rsvp: 'no' },
    { firstName: 'Jacob', lastName: 'Sanchez', rsvp: 'yes' },
    { firstName: 'Courtney', lastName: 'Morris', rsvp: 'pending' },
    { firstName: 'Christopher', lastName: 'Rogers', rsvp: 'yes' },
    { firstName: 'Rebecca', lastName: 'Reed', rsvp: 'no' },
    { firstName: 'Austin', lastName: 'Cook', rsvp: 'yes' },
    { firstName: 'Victoria', lastName: 'Morgan', rsvp: 'pending' },
    { firstName: 'Ethan', lastName: 'Bell', rsvp: 'yes' },
    { firstName: 'Hannah', lastName: 'Murphy', rsvp: 'no' },
    { firstName: 'Dylan', lastName: 'Bailey', rsvp: 'yes' },
    { firstName: 'Olivia', lastName: 'Rivera', rsvp: 'pending' },
    { firstName: 'Nathan', lastName: 'Cooper', rsvp: 'yes' },
    { firstName: 'Alyssa', lastName: 'Richardson', rsvp: 'no' },
    { firstName: 'Christian', lastName: 'Cox', rsvp: 'yes' },
    { firstName: 'Brianna', lastName: 'Howard', rsvp: 'pending' },
    { firstName: 'Jonathan', lastName: 'Ward', rsvp: 'yes' },
    { firstName: 'Kaitlyn', lastName: 'Torres', rsvp: 'no' },
    { firstName: 'Aaron', lastName: 'Peterson', rsvp: 'yes' },
    { firstName: 'Alexis', lastName: 'Gray', rsvp: 'pending' },
    { firstName: 'Samuel', lastName: 'Ramirez', rsvp: 'yes' },
    { firstName: 'Haley', lastName: 'James', rsvp: 'no' },
    { firstName: 'Joseph', lastName: 'Watson', rsvp: 'yes' },
    { firstName: 'Morgan', lastName: 'Brooks', rsvp: 'pending' },
    { firstName: 'Charles', lastName: 'Kelly', rsvp: 'yes' },
    { firstName: 'Sydney', lastName: 'Sanders', rsvp: 'no' },
    { firstName: 'Adam', lastName: 'Price', rsvp: 'yes' },
    { firstName: 'Jasmine', lastName: 'Bennett', rsvp: 'pending' },
    { firstName: 'Patrick', lastName: 'Wood', rsvp: 'yes' },
    { firstName: 'Erin', lastName: 'Barnes', rsvp: 'no' },
    { firstName: 'Sean', lastName: 'Ross', rsvp: 'yes' },
    { firstName: 'Brooke', lastName: 'Henderson', rsvp: 'pending' },
    { firstName: 'Jason', lastName: 'Coleman', rsvp: 'yes' },
    { firstName: 'Madison', lastName: 'Jenkins', rsvp: 'no' },
    { firstName: 'Kyle', lastName: 'Perry', rsvp: 'yes' },
    { firstName: 'Taylor', lastName: 'Powell', rsvp: 'pending' },
  ];

  type SortKey = 'firstName' | 'lastName' | 'rsvp';

  function sortGuestList(list: typeof guestList, key: SortKey) {
    return [...list].sort((a, b) => {
      const valA = (a[key] || '').toLowerCase();
      const valB = (b[key] || '').toLowerCase();
      if (valA < valB) return -1;
      if (valA > valB) return 1;
      return 0;
    });
  }
  const [sortKey, setSortKey] = React.useState<SortKey>('firstName');
  const sortedGuestList = sortGuestList(guestList, sortKey);

  return (
    <div style={{ padding: '16px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>{tq`Guest List`}</h2>
        <label style={{ display: 'flex', alignItems: 'center' }}>
          {tq`Sort by:`}{' '}
          <select
            value={sortKey}
            onBlur={e => setSortKey(e.target.value as SortKey)}
            style={{ marginLeft: 8 }}
          >
            <option value="firstName">{tq`First Name`}</option>
            <option value="lastName">{tq`Last Name`}</option>
            <option value="rsvp">{tq`RSVP`}</option>
          </select>
        </label>
      </div>
      {sortedGuestList.map((guest, idx) => {
        const initials = `${guest.firstName ? guest.firstName[0] : ''}${guest.lastName ? guest.lastName[0] : ''}`.toUpperCase();
        let rsvpIcon;
        if (guest.rsvp === 'accepted') {
          rsvpIcon = (
            <span
              role="img"
              aria-label={tq`Accepted`}
              title={tq`Accepted`}
              style={{ color: 'green' }}
            >
              ✔️
            </span>
          );
        } else if (guest.rsvp === 'declined') {
          rsvpIcon = (
            <span
              role="img"
              aria-label={tq`Declined`}
              title={tq`Declined`}
              style={{ color: 'red' }}
            >
              ❌
            </span>
          );
        } else {
          rsvpIcon = (
            <span
              role="img"
              aria-label={tq`Pending`}
              title={tq`Pending`}
              style={{ color: 'gray' }}
            >
              ⏳
            </span>
          );
        }
        return (
          <div
            key={idx}
            style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: '50%',
                background: '#eee',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 'bold',
                fontSize: 18,
                marginRight: 12,
              }}
            >
              {initials}
            </div>
            <div style={{ flex: 1 }}>
              {guest.firstName} {guest.lastName}
            </div>
            <div>{rsvpIcon}</div>
          </div>
        );
      })}
    </div>
  );
};

export default ModernGuestList;
